import React, { useState, useEffect } from "react";
import axios from "axios";
import { testUrl } from "../../../user/home/BaseData";
import styles from "./DormitoryAdmin.module.css";
import { FaTrashAlt, FaFilePdf } from "react-icons/fa";

const DormitoryAdmin = () => {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchApplications = async () => {
        try {
            const response = await axios.get(`${testUrl}/api/dormitory-applications/`);
            setApplications(response.data);
        } catch (error) {
            console.error("Error fetching applications:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchApplications();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Haqiqatan ham ushbu arizani o'chirib tashlamoqchimisiz?")) {
            try {
                await axios.delete(`${testUrl}/api/dormitory-applications/${id}/`);
                setApplications(applications.filter(app => app.id !== id));
            } catch (error) {
                console.error("Error deleting application:", error);
                alert("O'chirishda xatolik yuz berdi.");
            }
        }
    };

    const handleDownloadPdf = async (id, appNum, fullName) => {
        try {
            const response = await axios.get(
                `${testUrl}/api/dormitory-applications/${id}/download-pdf/`,
                { responseType: "blob" }
            );
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Shartnoma_${appNum}_${fullName}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("PDF yuklab olishda xatolik:", err);
            alert("Shartnoma PDF yuklab olishda xatolik yuz berdi.");
        }
    };

    if (loading) return <div>Yuklanmoqda...</div>;

    return (
        <div className={styles.container}>
            <h2 className={styles.heading}>Yotoqxona uchun kelib tushgan arizalar</h2>
            <div className={styles.tableResponsive}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>№</th>
                            <th>Ariza raqami</th>
                            <th>F.I.SH</th>
                            <th>Bosqich</th>
                            <th>Kurs</th>
                            <th>Yo'nalish</th>
                            <th>JSHSHR</th>
                            <th>Sana</th>
                            <th>Amallar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {applications.map((app, index) => (
                            <tr key={app.id}>
                                <td>{index + 1}</td>
                                <td>#{app.application_number}</td>
                                <td>{app.fullName}</td>
                                <td>{app.educationLevel}</td>
                                <td>{app.course}</td>
                                <td>{app.direction}</td>
                                <td>{app.jshshr}</td>
                                <td>{new Date(app.created_at).toLocaleDateString()}</td>
                                <td>
                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                        <button 
                                            className={styles.downloadBtn} 
                                            onClick={() => handleDownloadPdf(app.id, app.application_number, app.fullName)}
                                            title="Shartnoma PDF"
                                        >
                                            <FaFilePdf /> Shartnoma
                                        </button>
                                        <button className={styles.deleteBtn} onClick={() => handleDelete(app.id)} title="O'chirish">
                                            <FaTrashAlt />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DormitoryAdmin;
